var map = {
	"../..//print/print.module": [
		"./src/app/print/print.module.ts",
		"print-print-module"
	],
	"../..//report/report.module": [
		"./src/app/report/report.module.ts",
		"common",
		"report-report-module"
	],
	"../../pages/accounting/accounting.module": [
		"./src/app/pages/accounting/accounting.module.ts",
		"common",
		"pages-accounting-accounting-module"
	],
	"../../pages/accpostingsetup/accpostingsetup.module": [
		"./src/app/pages/accpostingsetup/accpostingsetup.module.ts",
		"common",
		"pages-accpostingsetup-accpostingsetup-module"
	],
	"../../pages/batch-number-enquiry/batch-number-enquiry.module": [
		"./src/app/pages/batch-number-enquiry/batch-number-enquiry.module.ts",
		"common",
		"pages-batch-number-enquiry-batch-number-enquiry-module"
	],
	"../../pages/billpay-walkin/billpay-walkin.module": [
		"./src/app/pages/billpay-walkin/billpay-walkin.module.ts",
		"default~pages-billpay-billpay-module~pages-billpay-walkin-billpay-walkin-module~pages-change-pay-cha~37588d4b",
		"common",
		"pages-billpay-walkin-billpay-walkin-module"
	],
	"../../pages/billpay/billpay.module": [
		"./src/app/pages/billpay/billpay.module.ts",
		"default~pages-billpay-billpay-module~pages-billpay-walkin-billpay-walkin-module~pages-change-pay-cha~37588d4b",
		"common",
		"pages-billpay-billpay-module"
	],
	"../../pages/booking-arrive/booking-arrive.module": [
		"./src/app/pages/booking-arrive/booking-arrive.module.ts",
		"default~pages-booking-arrive-booking-arrive-module~pages-booking-booking-module",
		"common",
		"pages-booking-arrive-booking-arrive-module"
	],
	"../../pages/booking/booking.module": [
		"./src/app/pages/booking/booking.module.ts",
		"default~pages-booking-arrive-booking-arrive-module~pages-booking-booking-module",
		"common",
		"pages-booking-booking-module"
	],
	"../../pages/change-pay/change-pay.module": [
		"./src/app/pages/change-pay/change-pay.module.ts",
		"default~pages-billpay-billpay-module~pages-billpay-walkin-billpay-walkin-module~pages-change-pay-cha~37588d4b",
		"common",
		"pages-change-pay-change-pay-module"
	],
	"../../pages/chartaccmonthendposting/chartaccmonthendposting.module": [
		"./src/app/pages/chartaccmonthendposting/chartaccmonthendposting.module.ts",
		"common",
		"pages-chartaccmonthendposting-chartaccmonthendposting-module"
	],
	"../../pages/copy-prescription/copy-prescription.module": [
		"./src/app/pages/copy-prescription/copy-prescription.module.ts",
		"default~pages-billpay-billpay-module~pages-billpay-walkin-billpay-walkin-module~pages-change-pay-cha~37588d4b",
		"default~pages-copy-prescription-copy-prescription-module~pages-tprescription-tprescription-module",
		"common",
		"pages-copy-prescription-copy-prescription-module"
	],
	"../../pages/debug/debug.module": [
		"./src/app/pages/debug/debug.module.ts",
		"pages-debug-debug-module"
	],
	"../../pages/dishes-plan/dishes-plan.module": [
		"./src/app/pages/dishes-plan/dishes-plan.module.ts",
		"default~pages-billpay-billpay-module~pages-billpay-walkin-billpay-walkin-module~pages-change-pay-cha~37588d4b",
		"common",
		"pages-dishes-plan-dishes-plan-module"
	],
	"../../pages/dishes/dishes.module": [
		"./src/app/pages/dishes/dishes.module.ts",
		"common",
		"pages-dishes-dishes-module"
	],
	"../../pages/employee-leave/employee-leave.module": [
		"./src/app/pages/employee-leave/employee-leave.module.ts",
		"common",
		"pages-employee-leave-employee-leave-module"
	],
	"../../pages/historyByDate/historyByDate.module": [
		"./src/app/pages/historyByDate/historyByDate.module.ts",
		"default~pages-billpay-billpay-module~pages-billpay-walkin-billpay-walkin-module~pages-change-pay-cha~37588d4b",
		"common",
		"pages-historyByDate-historyByDate-module"
	],
	"../../pages/home/home.module": [
		"./src/app/pages/home/home.module.ts",
		"pages-home-home-module"
	],
	"../../pages/importExportMaster/importExportMaster.module": [
		"./src/app/pages/importExportMaster/importExportMaster.module.ts",
		"common",
		"pages-importExportMaster-importExportMaster-module"
	],
	"../../pages/inbound/inbound.module": [
		"./src/app/pages/inbound/inbound.module.ts",
		"default~pages-billpay-billpay-module~pages-billpay-walkin-billpay-walkin-module~pages-change-pay-cha~37588d4b",
		"common",
		"pages-inbound-inbound-module"
	],
	"../../pages/journal/journal.module": [
		"./src/app/pages/journal/journal.module.ts",
		"default~pages-billpay-billpay-module~pages-billpay-walkin-billpay-walkin-module~pages-change-pay-cha~37588d4b",
		"common",
		"pages-journal-journal-module"
	],
	"../../pages/login-management/login-management.module": [
		"./src/app/pages/login-management/login-management.module.ts",
		"common",
		"pages-login-management-login-management-module"
	],
	"../../pages/login-user/login-user.module": [
		"./src/app/pages/login-user/login-user.module.ts",
		"common",
		"pages-login-user-login-user-module"
	],
	"../../pages/material-cat/material-cat.module": [
		"./src/app/pages/material-cat/material-cat.module.ts",
		"common",
		"pages-material-cat-material-cat-module"
	],
	"../../pages/material-list/material-list.module": [
		"./src/app/pages/material-list/material-list.module.ts",
		"default~pages-billpay-billpay-module~pages-billpay-walkin-billpay-walkin-module~pages-change-pay-cha~37588d4b",
		"common",
		"pages-material-list-material-list-module"
	],
	"../../pages/material/material.module": [
		"./src/app/pages/material/material.module.ts",
		"common",
		"pages-material-material-module"
	],
	"../../pages/medicine-type/medicine-type.module": [
		"./src/app/pages/medicine-type/medicine-type.module.ts",
		"common",
		"pages-medicine-type-medicine-type-module"
	],
	"../../pages/on-consult/on-consult.module": [
		"./src/app/pages/on-consult/on-consult.module.ts",
		"default~pages-billpay-billpay-module~pages-billpay-walkin-billpay-walkin-module~pages-change-pay-cha~37588d4b",
		"default~pages-on-consult-on-consult-module~pages-tpatient-tpatient-module",
		"common",
		"pages-on-consult-on-consult-module"
	],
	"../../pages/outbound/outbound.module": [
		"./src/app/pages/outbound/outbound.module.ts",
		"common",
		"pages-outbound-outbound-module"
	],
	"../../pages/outstanding/outstanding.module": [
		"./src/app/pages/outstanding/outstanding.module.ts",
		"pages-outstanding-outstanding-module"
	],
	"../../pages/patient-history/patient-history.module": [
		"./src/app/pages/patient-history/patient-history.module.ts",
		"pages-patient-history-patient-history-module"
	],
	"../../pages/physio/physio.module": [
		"./src/app/pages/physio/physio.module.ts",
		"default~pages-billpay-billpay-module~pages-billpay-walkin-billpay-walkin-module~pages-change-pay-cha~37588d4b",
		"common",
		"pages-physio-physio-module"
	],
	"../../pages/prescriptionPickList/prescriptionPickList.module": [
		"./src/app/pages/prescriptionPickList/prescriptionPickList.module.ts",
		"default~pages-billpay-billpay-module~pages-billpay-walkin-billpay-walkin-module~pages-change-pay-cha~37588d4b",
		"common",
		"pages-prescriptionPickList-prescriptionPickList-module"
	],
	"../../pages/prescriptionlist/prescriptionlist.module": [
		"./src/app/pages/prescriptionlist/prescriptionlist.module.ts",
		"default~pages-billpay-billpay-module~pages-billpay-walkin-billpay-walkin-module~pages-change-pay-cha~37588d4b",
		"common",
		"pages-prescriptionlist-prescriptionlist-module"
	],
	"../../pages/questionnaire/questionnaire.module": [
		"./src/app/pages/questionnaire/questionnaire.module.ts",
		"pages-questionnaire-questionnaire-module"
	],
	"../../pages/report-control/report-control.module": [
		"./src/app/pages/report-control/report-control.module.ts",
		"common",
		"pages-report-control-report-control-module"
	],
	"../../pages/role-permission/role-permission.module": [
		"./src/app/pages/role-permission/role-permission.module.ts",
		"common",
		"pages-role-permission-role-permission-module"
	],
	"../../pages/tbed/tbed.module": [
		"./src/app/pages/tbed/tbed.module.ts",
		"pages-tbed-tbed-module"
	],
	"../../pages/tbookaux/tbookaux.module": [
		"./src/app/pages/tbookaux/tbookaux.module.ts",
		"pages-tbookaux-tbookaux-module"
	],
	"../../pages/tchangeacct/tchangeacct.module": [
		"./src/app/pages/tchangeacct/tchangeacct.module.ts",
		"common",
		"pages-tchangeacct-tchangeacct-module"
	],
	"../../pages/temployee/temployee.module": [
		"./src/app/pages/temployee/temployee.module.ts",
		"common",
		"pages-temployee-temployee-module"
	],
	"../../pages/tgrn/tgrn.module": [
		"./src/app/pages/tgrn/tgrn.module.ts",
		"default~pages-tgrn-tgrn-module~pages-tpurchase-order-tpurchase-order-module",
		"common",
		"pages-tgrn-tgrn-module"
	],
	"../../pages/titem-cate/titem-cate.module": [
		"./src/app/pages/titem-cate/titem-cate.module.ts",
		"common",
		"pages-titem-cate-titem-cate-module"
	],
	"../../pages/titem/titem.module": [
		"./src/app/pages/titem/titem.module.ts",
		"common",
		"pages-titem-titem-module"
	],
	"../../pages/tmedicine/tmedicine.module": [
		"./src/app/pages/tmedicine/tmedicine.module.ts",
		"common",
		"pages-tmedicine-tmedicine-module"
	],
	"../../pages/tpackage/tpackage.module": [
		"./src/app/pages/tpackage/tpackage.module.ts",
		"common",
		"pages-tpackage-tpackage-module"
	],
	"../../pages/tpatient-type/tpatient-type.module": [
		"./src/app/pages/tpatient-type/tpatient-type.module.ts",
		"pages-tpatient-type-tpatient-type-module"
	],
	"../../pages/tpatient/tpatient.module": [
		"./src/app/pages/tpatient/tpatient.module.ts",
		"default~pages-billpay-billpay-module~pages-billpay-walkin-billpay-walkin-module~pages-change-pay-cha~37588d4b",
		"default~pages-on-consult-on-consult-module~pages-tpatient-tpatient-module",
		"common",
		"pages-tpatient-tpatient-module"
	],
	"../../pages/tpayment/tpayment.module": [
		"./src/app/pages/tpayment/tpayment.module.ts",
		"common",
		"pages-tpayment-tpayment-module"
	],
	"../../pages/tprescription/tprescription.module": [
		"./src/app/pages/tprescription/tprescription.module.ts",
		"default~pages-billpay-billpay-module~pages-billpay-walkin-billpay-walkin-module~pages-change-pay-cha~37588d4b",
		"default~pages-copy-prescription-copy-prescription-module~pages-tprescription-tprescription-module",
		"common",
		"pages-tprescription-tprescription-module"
	],
	"../../pages/tpricebook/tpricebook.module": [
		"./src/app/pages/tpricebook/tpricebook.module.ts",
		"common",
		"pages-tpricebook-tpricebook-module"
	],
	"../../pages/tpurchase-order/tpurchase-order.module": [
		"./src/app/pages/tpurchase-order/tpurchase-order.module.ts",
		"default~pages-billpay-billpay-module~pages-billpay-walkin-billpay-walkin-module~pages-change-pay-cha~37588d4b",
		"default~pages-tgrn-tgrn-module~pages-tpurchase-order-tpurchase-order-module",
		"common",
		"pages-tpurchase-order-tpurchase-order-module"
	],
	"../../pages/tshop-bldg/tshop-bldg.module": [
		"./src/app/pages/tshop-bldg/tshop-bldg.module.ts",
		"pages-tshop-bldg-tshop-bldg-module"
	],
	"../../pages/tshop/tshop.module": [
		"./src/app/pages/tshop/tshop.module.ts",
		"pages-tshop-tshop-module"
	],
	"../../pages/tvendor/tvendor.module": [
		"./src/app/pages/tvendor/tvendor.module.ts",
		"pages-tvendor-tvendor-module"
	],
	"../../pages/twhse/twhse.module": [
		"./src/app/pages/twhse/twhse.module.ts",
		"common",
		"pages-twhse-twhse-module"
	],
	"../../pages/void-voucher/void-voucher.module": [
		"./src/app/pages/void-voucher/void-voucher.module.ts",
		"default~pages-billpay-billpay-module~pages-billpay-walkin-billpay-walkin-module~pages-change-pay-cha~37588d4b",
		"common",
		"pages-void-voucher-void-voucher-module"
	],
	"../../pages/waiting-consult/waiting-consult.module": [
		"./src/app/pages/waiting-consult/waiting-consult.module.ts",
		"default~pages-billpay-billpay-module~pages-billpay-walkin-billpay-walkin-module~pages-change-pay-cha~37588d4b",
		"common",
		"pages-waiting-consult-waiting-consult-module"
	],
	"../../pages/xray/xray.module": [
		"./src/app/pages/xray/xray.module.ts",
		"default~pages-billpay-billpay-module~pages-billpay-walkin-billpay-walkin-module~pages-change-pay-cha~37588d4b",
		"common",
		"pages-xray-xray-module"
	],
	"./pages/main/main.module": [
		"./src/app/pages/main/main.module.ts",
		"common",
		"pages-main-main-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;